import { render, staticRenderFns } from "./CountriesStatesSettings.vue?vue&type=template&id=0c5b04fd&scoped=true"
import script from "./CountriesStatesSettings.vue?vue&type=script&lang=js"
export * from "./CountriesStatesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b04fd",
  null
  
)

export default component.exports